/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState } from 'react';
import { AppContext } from '../../App';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getAmountInCent } from '../../data/utils/getAmountInCent';
import { getConfiguration } from '../../data/utils/configuration';
import { getCurrencyValue } from '../../data/utils/getCurrencyValue';
import { getLocaleDotRound } from '../../data/utils/getLocaleDotRound';
import { getPrintableAmount } from '../../data/utils/getPrintableAmount';
import { getValidAmountString } from '../../data/utils/getValidAmountString';
import { labels } from '../../data/labels';

function FastbetAmount(props) {
	const betslipContext = useContext(BetslipContext) ;
	const appContext = React.useContext(AppContext) ;
	let conf = getConfiguration();
	let mult = conf.cs.m;
	let nDec = conf.cs.nd;
	let charDecimalBrowser = getLocaleDotRound().round;
    const amountUnit = betslipContext.minimumUnitAmount;
    const minimumAmount = betslipContext.minimumBetAmount;
    const minimum = getCurrencyValue(minimumAmount,conf.cs.m, conf.cs.nd, conf.cs.ct);
    const unit = getCurrencyValue(amountUnit,conf.cs.m, conf.cs.nd, conf.cs.ct);
    const errorMessage = `${labels['carrello.error.minimum_amount_part1']} ${minimum} ${labels['carrello.error.minimum_amount_part2']} ${unit}`;
    const [showCalc, toggleCalc] = useState(false);
    const [printableAmount, setPrintableAmount] = useState(getPrintableAmount(minimumAmount, conf.cs.m, conf.cs.nd));
    const [showError, setShowError] = useState(false);
   
   function setAmountFromCalc(amountCalc){
	   amountCalc = amountCalc * mult;
	   amountCalc = getPrintableAmount(amountCalc, mult, nDec);
	   setAmount(amountCalc);
   }

   function setAmount(newAmount){
	   // get a valid input field value for this amount: only number and dot, and max nDec digit after it
	   newAmount = getValidAmountString(newAmount);
	   // putting the "browser decimal dot" instead of the "." for the float type
	   let fieldTextValue = newAmount;
	   fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);

       let showErrorMessage = false;
	   if(isNaN(newAmount) === false && newAmount.length > 0){
            const amountInCent = getAmountInCent(parseFloat(newAmount), mult);
            const isMultiple = amountInCent % amountUnit === 0;
	        if (amountInCent < minimumAmount || isMultiple === false ) {
                showErrorMessage = true;
            }
	   }

       setPrintableAmount(fieldTextValue);
       setShowError(showErrorMessage);
	}
   
    function addChar(symb){
    	symb = symb + '';
    	let amountString = printableAmount + '';
    	if (printableAmount === '0') {
    		amountString = '';
    	}
    	amountString = amountString + symb;
    	setAmount(amountString);
    }

    function enableFastbet() {
        const amountInCent = getAmountInCent(parseFloat(printableAmount), mult);
        appContext.toggleFastbetPopup();
        betslipContext.enableAddAndBet(amountInCent);
    }

    const fastbetEnabled = betslipContext.isAddAndBetEnabled();
    
    return (
        <>
            <div  className="inserimento-puntata">
                <div className={"d-flex align-items-center justify-content-between"} >
                        <p className={"label-for-amount-input ellipsis"}>{labels['mybets.stake']}</p>
                        <input type="text" onChange={e => setAmount(e.target.value + "")}
                                className="input-calc calcolatrice-input"
                                value={printableAmount} placeholder={labels['carrello.puntata']} />
                </div>
                <div className="bottoni-calc">
                    <input type="button" onClick={() => setAmountFromCalc(3)} value={getPrintableAmount(3 * mult, mult, nDec)} />
                    <input type="button" onClick={() => setAmountFromCalc(5)} value={getPrintableAmount(5 * mult, mult, nDec)} />
                    <input type="button" onClick={() => setAmountFromCalc(10)} value={getPrintableAmount(10 * mult, mult, nDec)} />
                    <input type="button" onClick={() => setAmountFromCalc(15)}value={getPrintableAmount(15 * mult, mult, nDec)} />
                    <a onClick={() =>  toggleCalc(!showCalc)} className="apri-calc bg-nero bianco bordo-tondo pointer">
                        <i className="fas fa-calculator"></i>
                    </a>
                </div>
                {showCalc &&
                    <div className="calcSingola-keys margine-su-mezzo">
                        <div className="riga-calc">
                            {[1, 2, 3].map((value, i) => {
                                return (
                                    <button key={i} onClick={e => addChar(e.target.value)} type="button" value={value}>{value}</button>
                                );
                            })}
                        </div>
                        <div className="riga-calc">
                            {[4, 5, 6].map((value, i) => {
                                return (
                                    <button key={i} onClick={e => addChar(e.target.value)} type="button" value={value}>{value}</button>
                                );
                            })}
                        </div>
                        <div className="riga-calc">
                            {[7, 8, 9].map((value, i) => {
                                return (
                                    <button key={i} onClick={e => addChar(e.target.value)} type="button" value={value}>{value}</button>
                                );
                            })}
                        </div>
                        <div className="riga-calc">
                            {nDec > 0 &&
                                <button onClick={e => addChar(e.target.value)} type="button" className="decimal" value={charDecimalBrowser}>{charDecimalBrowser}</button>
                            }
                            <button onClick={e => addChar(0)} type="button" value={0}>0</button>
                            <button onClick={() => setAmount('0')} type="button" className="all-clear bg-rosso bianco" value="all-clear">C</button>
                        </div>
                    </div>
                }
            </div>
            {showError ?
                <span className="testo-piccolo nero">{errorMessage}</span>
                :
                <button className="customPopup__content__body__clickable customPopup__content__body__clickable--success text-uppercase mt-2" onClick={enableFastbet}>{fastbetEnabled ? labels['live.fastbet_popup.confirm'] : labels['live.fastbet_popup.enable']}</button>
            }
        </>
    );
}

export default FastbetAmount;